import { css } from '@emotion/react';
import { Icon } from '@spotnana/blocks/src/Icon';
import { themed } from '@spotnana/blocks/src/utils';
import Airplane from '@spotnana/pixel-react/dist/Icons/Airplane';
import { Surface } from '@spotnana/blocks/src/Surface';

import { Skeleton } from '@spotnana/blocks/src/Skeleton';
import { Divider } from '@spotnana/blocks/src/Divider';
import {
  airline_info_skeleton,
  airplane,
  container,
  container_skeleton,
  flight_summary_skeleton,
  origin_destination_skeleton,
} from './styles';
import CheckoutSectionHeader from '../../CheckoutSectionHeader';

const iconColor = themed(
  ({ palette }) => css`
    color: ${palette.icon.primary};
  `,
);

interface IProps {
  heading: string;
}

const TravelSummaryLoading = ({ heading }: IProps): JSX.Element => {
  return (
    <div>
      <CheckoutSectionHeader
        icon={<Icon css={iconColor} name="FlightFill" />}
        title={heading}
        dataTestId="travel-summary-section"
      />

      <Surface variant="base" shadow="card" css={container} borderRadius="outer">
        <div css={flight_summary_skeleton}>
          <Skeleton width="260px" height="24px" />
          <Skeleton width="260px" height="24px" />
        </div>

        <Divider />

        <div css={container_skeleton}>
          <div css={airplane}>
            <Airplane width={20} height={20} primaryColor="#EEE" />
          </div>
          <div css={airline_info_skeleton}>
            <Skeleton height="24px" width="70px" />
            <Skeleton height="24px" width="420px" />
          </div>
        </div>

        <div css={container_skeleton}>
          <div css={origin_destination_skeleton}>
            <Skeleton width="70px" height="14px" />
            <Skeleton width="140px" height="14px" />
            <Skeleton width="200px" height="14px" />
          </div>
          <div css={origin_destination_skeleton}>
            <Skeleton width="70px" height="14px" />
            <Skeleton width="140px" height="14px" />
            <Skeleton width="200px" height="14px" />
          </div>
        </div>
      </Surface>
    </div>
  );
};

export default TravelSummaryLoading;
